export const PALETTE_STORAGE_KEY = 'paletteId';

export const palettes = {
  default: {
    id: 'default',
    label: 'Default',
    accent: '#3EC121',
    accentHover: '#298914',
    accentDark: '#21830C',
    gradientMid: '#3fc320',
    gradientEnd: '#77e75e',
    alpha33: '#3EC12133',
    alpha66: '#3EC12166',
    alphaCC: '#3EC121CC',
    alpha1a: '#3EC1211A',
    sparkPrimary: '#3EC121',
    sparkEmissive: '#21830C',
    animationGradient: '#298914',
    allocationColors: ['#3EC121', '#9EEF8C', '#298914', '#BFBFBF'],
    vestingColors: ['#3EC12133', '#3EC12166', '#3EC12166', '#3EC121CC', '#3EC121'],
    glowRgb: '62, 193, 33',
    fluidFlame: ['#21830C', '#3EC121', '#2A9B14'],
  },
  lime: {
    id: 'lime',
    label: 'Lime',
    accent: '#84CC16',
    accentHover: '#65A30D',
    accentDark: '#65A30D',
    gradientMid: '#84CC16',
    gradientEnd: '#A3E635',
    alpha33: '#84CC1633',
    alpha66: '#84CC1666',
    alphaCC: '#84CC16CC',
    alpha1a: '#84CC161A',
    sparkPrimary: '#84CC16',
    sparkEmissive: '#65A30D',
    animationGradient: '#65A30D',
    allocationColors: ['#84CC16', '#A3E635', '#65A30D', '#BFBFBF'],
    vestingColors: ['#84CC1633', '#84CC1666', '#84CC1666', '#84CC16CC', '#84CC16'],
    glowRgb: '132, 204, 22',
    fluidFlame: ['#84CC16', '#A3E635', '#65A30D'],
  },
  emerald: {
    id: 'emerald',
    label: 'Emerald',
    accent: '#10B981',
    accentHover: '#059669',
    accentDark: '#047857',
    gradientMid: '#34D399',
    gradientEnd: '#6EE7B7',
    alpha33: '#10B98133',
    alpha66: '#10B98166',
    alphaCC: '#10B981CC',
    alpha1a: '#10B9811A',
    sparkPrimary: '#10B981',
    sparkEmissive: '#047857',
    animationGradient: '#059669',
    allocationColors: ['#10B981', '#34D399', '#059669', '#BFBFBF'],
    vestingColors: ['#10B98133', '#10B98166', '#10B98166', '#10B981CC', '#10B981'],
    glowRgb: '16, 185, 129',
    fluidFlame: ['#047857', '#10B981', '#34D399'],
  },
  cyan: {
    id: 'cyan',
    label: 'Cyan',
    accent: '#14B8A6',
    accentHover: '#0D9488',
    accentDark: '#0F766E',
    gradientMid: '#2DD4BF',
    gradientEnd: '#5EEAD4',
    alpha33: '#14B8A633',
    alpha66: '#14B8A666',
    alphaCC: '#14B8A6CC',
    alpha1a: '#14B8A61A',
    sparkPrimary: '#14B8A6',
    sparkEmissive: '#0F766E',
    animationGradient: '#0D9488',
    allocationColors: ['#14B8A6', '#2DD4BF', '#0D9488', '#BFBFBF'],
    vestingColors: ['#14B8A633', '#14B8A666', '#14B8A666', '#14B8A6CC', '#14B8A6'],
    glowRgb: '20, 184, 166',
    fluidFlame: ['#0F766E', '#14B8A6', '#2DD4BF'],
  },
  forest: {
    id: 'forest',
    label: 'Forest',
    accent: '#22C55E',
    accentHover: '#16A34A',
    accentDark: '#15803D',
    gradientMid: '#4ADE80',
    gradientEnd: '#86EFAC',
    alpha33: '#22C55E33',
    alpha66: '#22C55E66',
    alphaCC: '#22C55ECC',
    alpha1a: '#22C55E1A',
    sparkPrimary: '#22C55E',
    sparkEmissive: '#15803D',
    animationGradient: '#16A34A',
    allocationColors: ['#22C55E', '#4ADE80', '#16A34A', '#BFBFBF'],
    vestingColors: ['#22C55E33', '#22C55E66', '#22C55E66', '#22C55ECC', '#22C55E'],
    glowRgb: '34, 197, 94',
    fluidFlame: ['#15803D', '#22C55E', '#4ADE80'],
  },
};

export function getPaletteById(id) {
  if (id === 'violet') return palettes.forest;
  return palettes[id] || palettes.default;
}

export function applyPaletteToDocument(p) {
  const root = document.documentElement;
  root.style.setProperty('--palette-accent', p.accent);
  root.style.setProperty('--palette-accent-hover', p.accentHover);
  root.style.setProperty('--palette-accent-dark', p.accentDark);
  root.style.setProperty('--palette-gradient-mid', p.gradientMid);
  root.style.setProperty('--palette-gradient-end', p.gradientEnd);
  root.style.setProperty('--palette-alpha-33', p.alpha33);
  root.style.setProperty('--palette-alpha-66', p.alpha66);
  root.style.setProperty('--palette-alpha-cc', p.alphaCC);
  root.style.setProperty('--palette-alpha-1a', p.alpha1a);
  root.style.setProperty('--palette-accent-rgb', p.glowRgb);
  root.style.setProperty('--palette-shadow', `${p.accent}40`);
  root.style.setProperty('--palette-animation-gradient', p.animationGradient);
}

export function buildColorsFromPalette(p) {
  return {
    accent: p.accent,
    accentHover: p.accentHover,
    accentAlpha: p.alpha33,
    accentAlphaLight: p.alpha1a,
    sparkPrimary: p.sparkPrimary,
    sparkEmissive: p.sparkEmissive,
  };
}
